export default __webpack_public_path__ + "media/images/placeholders/green-background-f1e49d614c12f216ccfde043bb512f1b.png";